import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UserService } from "src/app/services/user.service";
import { UtilService } from 'src/app/service/util.service';
import { DataTablesModule } from 'angular-datatables';
import { API } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var $: any;

interface PreCadastro {
  id: number;
  razao_social: string;
  nome_fantasia: string;
  cnpj: string;
  email: string;
  iS_EMPRESA_GESTORA: boolean;
  status: string;
  idEncrypted: string;
}

@Component({
  selector: 'app-pre-cadastro-cliente',
  templateUrl: './pre-cadastro-cliente.component.html',
  styleUrls: ['./pre-cadastro-cliente.component.scss']
})
export class PreCadastroClienteComponent implements OnInit {
  @ViewChild('urlModal') urlModal: any;
  
  preCadastroForm: FormGroup;
  arrayTurma: PreCadastro[] = [];
  dtOptions: DataTables.Settings = {};
  urlCompletarCadastro: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: UserService,
    private modalService: NgbModal
  ) {
    this.preCadastroForm = this.fb.group({
      razao_social: ['', Validators.required],
      nome_fantasia: ['', Validators.required],
      cnpj: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      iS_EMPRESA_GESTORA: [false]
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.carregarPreCadastros();
  }

  mostrarUrl(item: PreCadastro): void {
    const baseUrl = window.location.origin;
    this.urlCompletarCadastro = `${baseUrl}/completar-cadastro-externo/${item.idEncrypted}`;
    this.modalService.open(this.urlModal, { centered: true });
  }

  copiarUrl(): void {
    const urlInput = document.getElementById('urlInput') as HTMLInputElement;
    urlInput.select();
    document.execCommand('copy');
    this.util.toasterShowSuccess('Sucesso', 'URL copiada para a área de transferência!');
  }

  carregarPreCadastros(): void {
    this.util.showLoading();
    this.ajax.get(`${API}Empresa/Empresa`)
      .subscribe({
        next: (response: any) => {
          this.arrayTurma = response.data.map((item: any) => ({
            id: item.id,
            razao_social: item.razaO_SOCIAL,
            nome_fantasia: item.nomE_FANTASIA,
            cnpj: item.cnpj,
            email: item.email,
            iS_EMPRESA_GESTORA: item.iS_EMPRESA_GESTORA,
            status: item.status || 'Em Andamento',
            idEncrypted: item.idEncrypted
          }));

          debugger
          this.util.closeLoading();
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError('Erro', 'Erro ao carregar pré-cadastros');
          console.error('Erro ao carregar pré-cadastros:', error);
        }
      });
  }

  onSubmit(): void {
    if (this.preCadastroForm.valid) {
      this.util.showLoading();
      const formData = {
        ...this.preCadastroForm.value,
        status: 'Em Andamento'
      };
      
      this.ajax.post(`${API}Empresa/Empresa`, formData)
        .subscribe({
          next: () => {
            this.util.closeLoading();
            this.util.toasterShowSuccess('Sucesso', 'Pré-cadastro realizado com sucesso!');
            this.preCadastroForm.reset();
            this.carregarPreCadastros();
          },
          error: (error) => {
            this.util.closeLoading();
            this.util.toasterShowError('Erro', 'Erro ao realizar pré-cadastro');
            console.error('Erro ao realizar pré-cadastro:', error);
          }
        });
    }
  }

  carregarEdicao(item) {
    this.router.navigate(['/cronograma', item.id]);
  }

  completarCadastro(item) {
    this.router.navigate(['/completar-cadastro', item.idEncrypted]);
  }

   valida() {
    if (this.preCadastroForm.controls['razao_social'].value == undefined || this.preCadastroForm.controls['razao_social'].value == "") {
      this.util.toasterShowError("Atenção", "Entre com a Razão Social");
      return false;
    }
    if (this.preCadastroForm.controls['cnpj'].value == undefined || this.preCadastroForm.controls['cnpj'].value == "") {
      this.util.toasterShowError("Atenção", "Entre com o CNPJ da Empresa");
      return false;
    }
    return true;
  }

  limpar() {
    this.preCadastroForm.reset();
  }

  desabilitar(id: number) {
    this.util.showLoading();
    this.ajax.post(`${API}Empresa/Empresa/Desabilitar/${id}`, {})
      .subscribe({
        next: () => {
          this.util.closeLoading();
          this.util.toasterShowSuccess('Sucesso', 'Empresa desabilitada com sucesso!');
          this.carregarPreCadastros();
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError('Erro', 'Erro ao desabilitar empresa');
          console.error('Erro ao desabilitar empresa:', error);
        }
      });
  }
}
